import React from "react";
import { Card, fmtWhen } from "./atoms";

export function DeliveriesTable({ deliveries }) {
  return (
    <Card kicker="Landing hub" title="Últimas entregas del webhook" testid="deliveries-card">
      {deliveries.length === 0 ? (
        <p className="text-sm text-clay-600" data-testid="deliveries-empty">Todavía no se ha enviado ningún evento.</p>
      ) : (
        <div className="overflow-x-auto -mx-2">
          <table className="w-full text-[12px]">
            <thead className="text-clay-500 text-left">
              <tr>
                <th className="px-2 py-1 font-medium">Cuándo</th>
                <th className="px-2 py-1 font-medium">Evento</th>
                <th className="px-2 py-1 font-medium">Viaje</th>
                <th className="px-2 py-1 font-medium">Respuesta</th>
                <th className="px-2 py-1 font-medium">Intento</th>
              </tr>
            </thead>
            <tbody>
              {deliveries.map((d) => (
                <tr key={d.delivery_id} className="border-t border-clay-100 align-top" data-testid={`delivery-row-${d.delivery_id}`}>
                  <td className="px-2 py-1.5 whitespace-nowrap text-clay-700 tabular">{fmtWhen(d.created_at)}</td>
                  <td className="px-2 py-1.5 font-mono text-clay-800">
                    <span className={`inline-block mr-1.5 px-1.5 py-0.5 rounded text-[10px] font-sans ${d.channel === "hub" ? "bg-clay-900 text-white" : "bg-clay-200 text-clay-800"}`}>{d.channel === "hub" ? "hub" : "webhook"}</span>
                    {d.event}
                  </td>
                  <td className="px-2 py-1.5 text-clay-700">{d.trip_name || d.curated_trip_id || "—"}</td>
                  <td className="px-2 py-1.5">
                    <span className={`inline-flex px-2 py-0.5 rounded-full font-medium ${d.ok ? "bg-emerald-100 text-emerald-800" : "bg-terracotta/15 text-terracotta"}`}>
                      {d.status_code ?? "sin respuesta"}
                    </span>
                    <span className="text-clay-500 ml-2 tabular">{d.duration_ms} ms</span>
                    {d.error && <div className="text-[11px] text-clay-600 mt-0.5 font-mono break-all max-w-md">{d.error}</div>}
                  </td>
                  <td className="px-2 py-1.5 text-clay-600 tabular">{d.attempt}/3</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
